// UpdateFaq.jsx
import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Navigate } from "react-router-dom";

import { Card, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";

export default class UpdateFaq extends Component {
  state = {
    faqId: "",
    question: "",
    answer: "",
    status: "active",
    is_delete: "no",

    message: "",
    notification: false,
    notiColor: "success",
    redirect: false,
    loading: false,
  };

  componentDidMount() {
    this.getFaq();
  }

  getFaq = () => {
    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }
    const id = window.location.pathname.split("/")[2];
    axios
      .get(Constants.getUrls.getAllFaqs + "/" + id)
      .then((resp) => {
        if (resp.data?.status === "success") {
          const d = resp.data.data || {};
          this.setState({
            faqId: d._id,
            question: d.question || "",
            answer: d.answer || "",
            status: d.status || "active",
            is_delete: d.is_delete || "no",
          });
        } else {
          this.setState({
            notification: true,
            notiColor: "warning",
            message: resp.data?.message || "Failed to fetch",
          });
        }
      })
      .catch((err) =>
        this.setState({
          notification: true,
          notiColor: "warning",
          message: err?.response?.data?.message || "Error fetching",
        })
      );
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { faqId, question, answer, status, is_delete } = this.state;

    if (!question) {
      this.setState({ notification: true, notiColor: "warning", message: "Question is required!" });
      setTimeout(() => this.setState({ notification: false, message: "" }), 2500);
      return;
    }

    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    const body = { question, answer, status, is_delete };
    this.setState({ loading: true });

    axios
      .put(Constants.putUrls.updateFaq + faqId, body)
      .then((resp) => {
        this.setState({
          notification: true,
          notiColor: "success",
          message: resp.data?.message || "Updated successfully!",
          loading: false,
        });
        setTimeout(() => this.setState({ notification: false, message: "", redirect: true }), 1200);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          notiColor: "warning",
          message: err?.response?.data?.message || "Update failed",
          loading: false,
        });
        setTimeout(() => this.setState({ notification: false, message: "" }), 3000);
      });
  };

  render() {
    if (this.state.redirect) return <Navigate to="/faqs" />;

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Update FAQ
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item sm={12}>
                    <TextField
                      type="text"
                      label="Question"
                      name="question"
                      onChange={this.handleInput}
                      value={this.state.question}
                      style={{ width: "100%" }}
                    />
                  </Grid>

                  <Grid item sm={12}>
                    <TextField
                      type="text"
                      label="Answer (small)"
                      name="answer"
                      onChange={this.handleInput}
                      value={this.state.answer}
                      style={{ width: "100%" }}
                      multiline
                      rows={4}
                    />
                  </Grid>

                  <Grid item sm={6}>
                    <InputLabel>Status</InputLabel>
                    <Select
                      value={this.state.status}
                      onChange={(e) => this.setState({ status: e.target.value })}
                      name="status"
                      style={{ width: "100%", height: "45px" }}
                    >
                      <MenuItem value="active">Active</MenuItem>
                      <MenuItem value="inactive">Inactive</MenuItem>
                    </Select>
                  </Grid>

                  <Grid item sm={6}>
                    <InputLabel>Is Delete</InputLabel>
                    <Select
                      value={this.state.is_delete}
                      onChange={(e) => this.setState({ is_delete: e.target.value })}
                      name="is_delete"
                      style={{ width: "100%", height: "45px" }}
                    >
                      <MenuItem value="no">No</MenuItem>
                      <MenuItem value="yes">Yes</MenuItem>
                    </Select>
                  </Grid>

                  <Grid item sm={12}>
                    <MDButton variant="contained" size="small" color="info" type="submit">
                      {this.state.loading ? "Updating..." : "Update"}
                    </MDButton>
                  </Grid>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="FAQ Admin"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
